//
// Module for a Generate Schedules wizard criteria step
//
rs.module("jobs/criteria/generateschedules/criteriastep",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, config) {

            var stepContainer = $.js(jsSelectors.stepContainer);

            var dateMethodRadioList = stepContainer.js(jsSelectors.dateMethodRadioList);
            var calculatedDatesRadio = dateMethodRadioList.js(jsSelectors.calculatedDatesRadio);

            var frequencySelect = stepContainer.js(jsSelectors.frequencySelect);
            var frequencySelectHelper = selectHelper.getHelper(frequencySelect);
            var firstDueDate = stepContainer.js(jsSelectors.firstDueDate);
            var secondDueDate = stepContainer.js(jsSelectors.secondDueDate);
            var endOfMonthCheckbox = stepContainer.js(jsSelectors.endOfMonthCheckbox);

            // clear/toggle date method fields as appropriate
            dateMethodRadioList.change(function () {
                var disable = !calculatedDatesRadio.is(':checked');

                if (disable) {
                    _clearDateMethodFields();

                    firstDueDate.prop('disabled', disable);
                    secondDueDate.prop('disabled', disable);
                    endOfMonthCheckbox.prop('disabled', disable);
                }

                frequencySelectHelper.setDisabled(disable);
            });

            // clear all fields
            function _clearDateMethodFields() {
                frequencySelect.clearErrors();
                frequencySelectHelper.setValue("");

                firstDueDate.val("").clearErrors();
                secondDueDate.val("").clearErrors();
                endOfMonthCheckbox.clearErrors();
                endOfMonthCheckbox.prop('checked', false);
            }

            // toggle appropriate date method fields
            frequencySelect.change(function () {
                if (this.value != "") {
                    firstDueDate.prop('disabled', false);

                    switch (parseInt(this.value)) {
                        // Due at Month End available
                        case config.paymentFrequency.biMonthly:
                        case config.paymentFrequency.monthly:
                        case config.paymentFrequency.quarterly:
                        case config.paymentFrequency.semiAnnual:
                            endOfMonthCheckbox.prop('disabled', false);

                            secondDueDate.val("").clearErrors();

                            secondDueDate.prop('disabled', true);
                            break;

                        // all available
                        case config.paymentFrequency.semiMonthly:
                            secondDueDate.prop('disabled', false);
                            endOfMonthCheckbox.prop('disabled', false);
                            break;

                        // only First Due available
                        default:
                            secondDueDate.val("").clearErrors();
                            endOfMonthCheckbox.clearErrors();
                            endOfMonthCheckbox.prop('checked', false);

                            secondDueDate.prop('disabled', true);
                            endOfMonthCheckbox.prop('disabled', true);
                            break;
                    }
                } else {
                    firstDueDate.val("").clearErrors();
                    secondDueDate.val("").clearErrors();
                    endOfMonthCheckbox.clearErrors();
                    endOfMonthCheckbox.prop('checked', false);

                    firstDueDate.prop('disabled', true);
                    secondDueDate.prop('disabled', true);
                    endOfMonthCheckbox.prop('disabled', true);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);